<template>
  <div class="flex">
    <div class="bg-white rounded-md shadow border-2 border-indigo-600">
      <div class="flex flex-wrap -mt-3 p-8">
        <h3 class="text-xl font-medium leading-6 text-gray-900 block pb-8 w-full">{{$t('treatments.treatment')}}</h3>
        <label class="font-medium pb-5 pr-6 2xl:w-1/4 w-2/4">
          {{$t('applications.status')}}
        </label>
        <div class="flex pb-5 pr-6 2xl:w-3/4 w-2/4">
          <status-badge :status="treatment.status"/>
        </div>
        <label class="font-medium pb-5 2xl:w-1/4 w-2/4">
          {{$t('treatments.treatment_type_id')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-3/4 w-2/4">
          {{$t('treatment-types.'+treatment.treatment_type_name)}}
        </div>
        <label v-if="treatment.volunteer_id" class="font-medium pb-5 2xl:w-1/4 w-2/4">
          {{$t('interventions.volunteer')}}
        </label>
        <div v-if="treatment.volunteer_id" class="pb-5 pr-6 2xl:w-3/4 w-2/4">
          {{treatment.volunteer_name}}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/4 w-2/4">
          {{$t('treatments.date_open')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-3/4 w-2/4">
          {{$filters.formatDate(treatment.date_open)}}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/4 w-2/4" v-if="treatment.status.value == 3">
          {{$t('treatments.date_closed')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-3/4 w-2/4" v-if="treatment.status.value == 3">
          {{$filters.formatDate(treatment.date_closed)}}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/4 w-2/4" v-if="treatment.status.value == 3">
          {{$t('treatments.reason_closed')}}
        </label>
        <div class="pb-5 pr-6 2xl:w-3/4 w-2/4" v-if="treatment.status.value == 3">
          {{treatment.reason_closed}}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/4 w-2/4">
          {{$t('treatments.paper_file')}}
        </label>
        <div class="flex pb-5 pr-6 2xl:w-3/4 w-2/4">
          <yes-no :value="treatment.paper_file"/>
        </div>
        <Link  v-if="!viaVolunteer" class="btn-indigo inline-flex items-center mb-3 lg:mb-0 max-w-md" :href="`/applicants/${treatment.applicant_id}/treatments/${treatment.id}/edit/`">
          <span>{{$t('global.update')}}</span>
        </Link>
      </div>
    </div>
  </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
import StatusBadge from '@/Shared/StatusBadge'
import YesNo from '@/Shared/YesNo.vue'
export default{
  props:{
    treatment: Object,
    viaVolunteer: {
      type: Boolean,
      default: false
    },
  },
  components:{Link,StatusBadge,YesNo}
}
</script>
